<style scoped>

</style>
<template>
  <!-- <transition name="el-zoom-in-top"> -->
  <div class="content-wrapper">
    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">loading ...</h3>
        </div>
        <div class="box-body" v-loading="loading">
          
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from 'axios';
// import EventBus from '../../../eventBus.js';
export default {
  data: () => {
    return {
      
      loading: true
    }
  },
  created: function() {
    this.initialize();
  },
  methods: {
    initialize() {
     axios.get(`${BASE_URL}v1/spot-diagnostics/${this.$route.params.adSpotId}/`).then((res) => {
        console.log(res);
        window.location = res.data;
     })

    },
  },
  // props: {
  //    disabled: Boolean,
  // },
  computed: {
    isComplete() {
      return this.dfp.prebid_currency;
    }
  }
};

</script>



// WEBPACK FOOTER //
// DiagRedirect.vue?5b81965e